<template>
  <div class="form-box">
    <div class="custom-nav nav-bar">
      <van-nav-bar :title="isModifyMode ? '信息修改' : '参训信息'" right-text="提交" fixed left-arrow @click-left="onClickLeft"
        @click-right="onClickRight" />
    </div>



    <div class="content-box fixed">
      <div>
        <!-- 项目信息展示 -->
        <div v-if="isModifyMode && activityInfo" class="project-info-card">


          <!-- 红色提示信息 -->
          <div class="reject-alert">
            <div class="alert-title">您的活动报名信息已退回，请检查并修正错误后重新提交！</div>

            <!-- 退回原因列表 -->
            <div v-if="activityInfo.auditReason" class="reject-reasons">
              <!-- 分割线 -->
              <div class="divider"></div>

              <div class="reject-reason-title">退回原因：</div>

              <!-- 将auditReason按行分割显示（假设用换行符分隔） -->
              <div v-for="(reason, index) in parseRejectReasons(activityInfo.auditReason)" :key="index"
                class="reject-reason-item">
                {{ reason }}
              </div>

              <!-- 如果没有具体原因，显示默认文本 -->
              <div v-if="!activityInfo.auditReason" class="reject-reason-item">
                请根据审核意见修改您的报名信息
              </div>
            </div>
          </div>
        </div>
        <div class="title red">页面中*为必填项<span style="float: right; color: rgb(59, 112, 255);"
            @click="show = true">查看填写说明</span></div>
        <div class="form-info">
          <van-form ref="formRef">
            <div class="second-box">
              <div class="section-title">基本信息</div>

              <van-cell-group>
                <van-field v-model="form.name" size="large" name="name" label="姓名" required placeholder="请输入姓名，最多15个字"
                  :rules="rules.name" />
                <van-field label="身份证件" required value="" readonly size="large" />

                <van-field readonly required clickable size="large" v-model="form.documentTypeText" name="documentType"
                  label="身份证件类型" placeholder="请选择证件类型" @click="showPicker = true" right-icon="arrow" />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker show-toolbar :columns="documentTypeColumns" :columns-field-names="customFieldNames"
                    @confirm="onConfirmDocumentType" @cancel="showPicker = false" />
                </van-popup>
                <van-field v-model="form.documentNumber" size="large" label="" name="documentNumber"
                  placeholder="请输入证件号码" :rules="rules.documentNumber" />
                <van-field v-model="form.email" name="email" size="large" label="邮箱" required placeholder="请输入邮箱"
                  :rules="rules.email" />
                <van-field label="所在地" required value="" readonly size="large" />
                <van-field readonly clickable v-model="form.location" name="location" size="large" label=""
                  placeholder="请选择省市区" @click="showArea = true" right-icon="arrow" />

                <van-popup v-model="showArea" position="bottom">
                  <van-area :area-list="areaList" @confirm="onConfirmArea" @cancel="showArea = false" />
                </van-popup>
                <van-field v-model="form.detailedAddress" size="large" label="" name="detailedAddress"
                  placeholder="请输入详细地址，最多50个字" :rules="rules.detailedAddress" />
                <van-field readonly required clickable size="large" v-model="form.qualification" name="qualification"
                  label="学历" placeholder="请选择学历" @click="showQualificationPicker = true" right-icon="arrow"
                  :rules="[{ required: true, message: '请选择学历' }]" />
                <van-popup v-model="showQualificationPicker" position="bottom">
                  <van-picker show-toolbar :columns="qualificationColumns" @confirm="onConfirmQualification"
                    @cancel="showQualificationPicker = false" />
                </van-popup>
              </van-cell-group>
            </div>
            <div class="second-box">
              <div class="section-title">工作信息</div>
              <van-field v-model="form.employer" size="large" label="工作单位" name="employer" required
                placeholder="请输入工作单位，最多50个字" :rules="rules.employer" />
              <van-field label="学段学科" required value="" readonly size="large" />
              <van-field readonly clickable v-model="form.academicStage" size="large" name="academicStage" label="学段"
                placeholder="请选择学段" @click="showAcademicStagePicker = true" right-icon="arrow"
                :rules="[{ required: true, message: '请选择学段' }]" />
              <van-field v-model="form.discipline" size="large" name="discipline" label="学科" placeholder="请输入学科"
                :rules="rules.discipline" />
              <van-popup v-model="showAcademicStagePicker" position="bottom">
                <van-picker show-toolbar :columns="academicStageColumns" @confirm="onConfirmAcademicStage"
                  @cancel="showAcademicStagePicker = false" />
              </van-popup>
            </div>
          </van-form>
        </div>

        <van-popup v-model="show" position="bottom" :style="{ height: '60%' }">
          <div
            style="padding: 20px 0px; font-size: 18px; font-weight: bold; text-align: center; border-bottom: 1px solid rgb(238, 238, 238); background: rgb(255, 255, 255); position: fixed; width: 100%; margin-top: 0px;">
            请仔细阅读填写说明
            <i class="van-icon van-icon-cross van-popup__close-icon van-popup__close-icon--top-right"
              @click="show = false"></i>
          </div>
          <div class="ueditor-wrapper" style="margin: 70px 20px 20px;">
            <p style="white-space: pre-wrap;"><span style="color: rgb(255, 0, 0);"><strong><span
                    style="font-family: 微软雅黑; font-size: 14px;">*报名须知：</span></strong></span>
            </p>
            <p style="white-space: pre-wrap;"><span
                style="font-family: 微软雅黑; font-size: 14px; color: rgb(255, 0, 0);">1、基本信息-所在地，务必填写完整；</span>
            </p>
            <p style="white-space: pre-wrap;"><span
                style="font-family: 微软雅黑; font-size: 14px; color: rgb(255, 0, 0);">2、工作信息-学段学科，请选择本次竞赛项目：学前/小学/初中</span>
            </p>
            <p><br></p><br><br>
          </div>
          <div class="footer">
            <van-button block type="info" size="large" @click="show = false">关闭</van-button>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavBar from 'vant/lib/nav-bar';
import 'vant/lib/nav-bar/style';
import Field from 'vant/lib/field';
import 'vant/lib/field/style';
import Form from 'vant/lib/form';
import 'vant/lib/form/style';
import CellGroup from 'vant/lib/cell-group';
import 'vant/lib/cell-group/style';
import Cell from 'vant/lib/cell';
import 'vant/lib/cell/style';
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import Picker from 'vant/lib/picker';
import 'vant/lib/picker/style';
import Area from 'vant/lib/area';
import 'vant/lib/area/style';
import Button from 'vant/lib/button';
import 'vant/lib/button/style';
import NoticeBar from 'vant/lib/notice-bar';
import 'vant/lib/notice-bar/style';
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';

Vue.use(Button)
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(NavBar)
Vue.use(Field)
Vue.use(Form)
Vue.use(Area);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(NoticeBar);
Vue.use(Toast);

import { areaList } from '@vant/area-data';
import { addObj, updateObj, getSignupDetail } from '@/api/activity/index'
import { isNotEmpty, messageFail, messageWarn, messageSuccess, getAttachmentPreviewUrl, formatDate } from '@/utils/util'

export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      isModifyMode: false, // 是否为修改模式
      applyId: null, // 报名记录ID（修改模式使用）
      activityInfo: null, // 活动信息（修改模式显示）
      show: true,
      areaList: areaList,
      showArea: false,
      showPicker: false,
      showQualificationPicker: false,
      showAcademicStagePicker: false,
      form: {
        id: null, // 主键id（修改时提交）
        name: '',
        documentType: '', // 1:身份证, 2:护照, 3:军官证, 4:港澳通行证, 5:台湾通行证
        documentTypeText: '', // 显示的证件类型文本
        documentNumber: '',
        email: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        location: '', // 省市区名称
        detailedAddress: '',
        qualification: '',
        employer: '',
        academicStage: '',
        discipline: '',
      },
      // 证件类型映射
      documentTypeMap: {
        '身份证': '1',
        '护照': '2',
        '军官证': '3',
        '港澳通行证': '4',
        '台湾通行证': '5'
      },
      // 证件类型显示列
      documentTypeColumns: [
        { text: '身份证', value: '1' },
        { text: '护照', value: '2' },
        { text: '军官证', value: '3' },
        { text: '港澳通行证', value: '4' },
        { text: '台湾通行证', value: '5' }
      ],
      customFieldNames: {
        text: 'text',
        value: 'value'
      },
      qualificationColumns: ['大专以下', '大专', '本科', '硕士', '博士'],
      academicStageColumns: ['学前', '小学', '初中'],
      rules: {
        name: [
          { required: true, message: '请填写姓名' },
          {
            validator: (val) => {
              return val && val.length <= 15
            },
            message: '姓名最多15个字'
          }
        ],
        documentNumber: [
          { required: true, message: '请填写证件号码' },
          { validator: this.validateDocumentNumber, message: '证件号码格式不正确' }
        ],
        email: [
          { required: true, message: '请填写邮箱' },
          { validator: this.validateEmail, message: '邮箱格式不正确' }
        ],
        detailedAddress: [
          { required: true, message: '请填写详细地址' },
          {
            validator: (val) => {
              return val && val.length <= 50
            },
            message: '最多50个字'
          }
        ],
        employer: [
          { required: true, message: '请填写工作单位' },
          {
            validator: (val) => {
              return val && val.length <= 50
            },
            message: '最多50个字'
          }
        ],
        discipline: [
          { required: true, message: '请填写学科' },
          {
            validator: (val) => {
              return val && val.length <= 20
            },
            message: '学科最多20个字'
          }
        ]
      },
      banner_bg: require("@/assets/img/bg-img/bg2.jpg")
    }
  },
  created() {
    // 判断是否为修改模式
    this.detectMode()
    // 如果是修改模式，加载已有数据
    if (this.isModifyMode) {
      this.loadSignupDetail()
    } else {
      // 获取活动ID，这里假设从路由参数获取
      this.activityId = this.$route.query.id || '';
      if (!this.activityId) {
        console.error('未找到活动ID');
      }
    }
  },
  methods: {
    // 解析退回原因字符串，按行分割
    parseRejectReasons(reasonText) {
      if (!reasonText) return []

      // 按换行符、分号、句号等分割
      return reasonText
        .split(/[\n;。；]/)
        .map(item => item.trim())
        .filter(item => item.length > 0)
        .map((item, index) => {
          // 确保有数字序号
          if (/^\d+[\.、]/.test(item)) {
            return item
          } else {
            return `${index + 1}.${item}`
          }
        })
    },
    // 检测当前模式
    detectMode() {
      const routeQuery = this.$route.query
      const routeName = this.$route.name

      // 判断是否是修改模式
      if (routeQuery.id && (routeQuery.type === 'modify' || routeQuery.name === 'modify')) {
        this.isModifyMode = true
        this.show = false;
        this.applyId = routeQuery.id
        // 从待修改列表跳转过来时，可能还有activityId参数
        if (routeQuery.activityId) {
          this.activityId = routeQuery.activityId
        }
      } else {
        this.isModifyMode = false
      }

      // 设置页面标题
      document.title = this.isModifyMode ? '信息修改' : '参训信息'
    },

    // 格式化日期
    formatDate(dateTime) {
      if (!dateTime) return '--'
      return dateTime.split(' ')[0]
    },

    // 加载报名详情数据（修改模式）
    async loadSignupDetail() {
      try {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
        })

        // 获取报名详情
        const response = await getSignupDetail({ id: this.applyId })

        if (response.code === 200 && response.data) {
          const data = response.data

          // 保存活动信息
          this.activityInfo = {
            raceName: data.raceName,
            startTime: data.startTime,
            endTime: data.endTime,
            auditReason: data.auditReason
          }

          // 填充表单数据
          this.form.id = data.id
          this.form.name = data.name || ''
          this.form.documentType = data.documentType || ''
          this.form.documentNumber = data.documentNumber || ''
          this.form.email = data.email || ''
          this.form.provinceCode = data.provinceCode || ''
          this.form.cityCode = data.cityCode || ''
          this.form.districtCode = data.districtCode || ''
          this.form.location = data.location || ''
          this.form.detailedAddress = data.detailedAddress || ''
          this.form.qualification = data.qualification || ''
          this.form.employer = data.employer || ''
          this.form.academicStage = data.academicStage || ''
          this.form.discipline = data.discipline || ''

          // 设置证件类型显示文本
          const documentTypeItem = this.documentTypeColumns.find(item => item.value === data.documentType)
          if (documentTypeItem) {
            this.form.documentTypeText = documentTypeItem.text
          }

          // 如果路由中没有activityId，从数据中获取
          if (!this.activityId && data.activityId) {
            this.activityId = data.activityId
          }
        } else {
          Toast.fail(response.msg || '加载报名信息失败')
          setTimeout(() => {
            this.$router.go(-1)
          }, 1500)
        }
      } catch (error) {
        console.error('加载报名详情失败:', error)
        Toast.fail('加载失败，请重试')
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500)
      } finally {
        Toast.clear()
      }
    },

    // 证件号码验证
    validateDocumentNumber(val) {
      if (!val) return false;

      // 根据证件类型进行验证
      if (this.form.documentType === '1') {
        // 身份证验证
        const card15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
        const card18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        return card15.test(val) || card18.test(val)
      } else if (this.form.documentType === '2') {
        // 护照验证
        return /^[a-zA-Z0-9]{5,17}$/.test(val)
      } else if (this.form.documentType === '3') {
        // 军官证验证
        return /^[\u4e00-\u9fa5a-zA-Z0-9]{7,21}$/.test(val)
      } else if (this.form.documentType === '4') {
        // 港澳通行证验证
        return /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/.test(val)
      } else if (this.form.documentType === '5') {
        // 台湾通行证验证
        return /^[0-9]{8}$/.test(val)
      }

      return true; // 其他类型不验证格式
    },

    // 邮箱验证
    validateEmail(val) {
      if (!val) return false;
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegex.test(val)
    },

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1)
    },

    // 提交表单
    async onClickRight() {
      try {
        await this.$refs.formRef.validate();

        // 构建提交数据
        const submitData = {
          name: this.form.name,
          documentType: this.form.documentType,
          documentNumber: this.form.documentNumber,
          email: this.form.email,
          provinceCode: this.form.provinceCode,
          cityCode: this.form.cityCode,
          districtCode: this.form.districtCode,
          location: this.form.location,
          detailedAddress: this.form.detailedAddress,
          qualification: this.form.qualification,
          employer: this.form.employer,
          academicStage: this.form.academicStage,
          discipline: this.form.discipline
        };

        console.log('提交的数据:', submitData);

        let response
        let successMessage = ''

        if (this.isModifyMode) {
          // 修改模式：调用updateObj接口
          submitData.id = this.form.id
          submitData.status = 0 // 修改后状态重置为待审核
          response = await updateObj(submitData)
          successMessage = '修改成功'
        } else {
          // 新增模式：调用addObj接口
          submitData.activityId = this.activityId
          response = await addObj(submitData)
          successMessage = '提交成功'
        }

        if (response && response.code === 200) {
          messageSuccess(this, successMessage)
          // 提交成功后跳转页面
          setTimeout(() => {
            if (this.isModifyMode) {
              // 修改成功后跳转到报名列表或待修改列表
              this.$router.push({
                name: 'modify',
                query: {
                  success: true,
                  message: '修改成功'
                }
              })
            } else {
              // 新增成功后跳转页面
              this.toPage('choosegroup')
            }
          }, 1500)
        } else {
          messageFail(this, response.msg || '提交失败，请重试')
        }
      } catch (error) {
        console.log('验证失败或提交出错:', error)
        if (error && !error.name) {
          messageFail(this, '请检查表单填写是否正确')
        }
      }
    },

    // 选择证件类型
    onConfirmDocumentType(value, index) {
      const selectedItem = this.documentTypeColumns[index];
      this.form.documentType = selectedItem.value;
      this.form.documentTypeText = selectedItem.text;
      this.showPicker = false;
    },

    // 选择学历
    onConfirmQualification(value) {
      this.form.qualification = value;
      this.showQualificationPicker = false;
    },

    // 选择学段
    onConfirmAcademicStage(value) {
      this.form.academicStage = value;
      this.showAcademicStagePicker = false;
    },

    // 选择省市区
    onConfirmArea(area) {
      console.log('选择的省市区:', area);

      if (area && area.length > 0) {
        // 获取省市区名称
        this.form.location = area
          .filter((item) => !!item)
          .map((item) => item.name)
          .join('/');

        // 获取省市区代码
        if (area.length >= 1) {
          this.form.provinceCode = area[0].code;
        }
        if (area.length >= 2) {
          this.form.cityCode = area[1].code;
        }
        if (area.length >= 3) {
          this.form.districtCode = area[2].code;
        }
      }

      this.showArea = false;
    },

    // 页面跳转
    toPage(pageName) {
      this.$router.push({ name: pageName });
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.form-box {
  height: 100%;

  .nav-bar {
    position: relative;

    ::v-deep .van-icon {
      color: #000;
      font-size: 18px;
    }

    ::v-deep .van-nav-bar__right .van-nav-bar__text {
      font-size: 15px;
      color: #ee0a24 !important; // 修改模式时提交按钮为红色
      font-weight: 500;
    }

    ::v-deep .van-nav-bar__title {
      font-weight: 600;
    }
  }

  .modify-tip {
    position: fixed;
    top: 46px;
    left: 0;
    right: 0;
    z-index: 999;

    ::v-deep .van-notice-bar {
      padding: 10px 16px;
      background-color: #fff2f2 !important;

      .van-notice-bar__content {
        font-weight: 500;
      }

      .van-icon {
        color: #ee0a24;
      }
    }
  }

  .content-box {
    z-index: 999;
    padding: 14px 18px 41px;
    top: 46px;
    height: calc(100% - 46px);
    overflow-y: auto;

    &.with-modify-tip {
      top: 86px;
      height: calc(100% - 86px);
    }

    .project-info-card {
      background: #fff;
      border-radius: 8px;
      padding: 0;
      /* 改为0，在内部元素上控制间距 */
      margin-bottom: 20px;
      border: 1px dashed #ff976a;
      /* 橙色虚线边框，与图片完全一致 */
      position: relative;
      overflow: hidden;

      .project-header {
        padding: 16px 16px 12px 16px;
        border-bottom: 1px solid #f0f0f0;

        .project-name {
          font-size: 18px;
          font-weight: 600;
          color: #333;
          line-height: 1.4;
          margin-bottom: 8px;
        }

        .project-time {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #666;

          .label {
            color: #999;
            min-width: 70px;
            flex-shrink: 0;
          }

          .value {
            flex: 1;
            color: #666;
          }
        }
      }

      .reject-alert {
        padding: 16px;

        .alert-title {
          color: #ee0a24;
          /* 红色字体，与图片完全一致 */
          font-size: 15px;
          font-weight: 500;
          line-height: 1.5;
          margin-bottom: 12px;
          text-align: left;
        }

        .reject-reasons {
          .divider {
            height: 1px;
            background: #f0f0f0;
            margin: 12px 0;
          }

          .reject-reason-title {
            color: #ff976a;
            /* 橙色标题，与图片完全一致 */
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 8px;
          }

          .reject-reason-item {
            color: #ff976a;
            /* 橙色文字，与图片完全一致 */
            font-size: 14px;
            line-height: 1.6;
            margin-bottom: 6px;
            position: relative;
            // padding-left: 20px;

            &::before {
              // content: '';
              // position: absolute;
              // left: 8px;
              // top: 8px;
              // width: 4px;
              // height: 4px;
              // background: #ff976a;
              // border-radius: 50%;
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }

      /* 添加四个角的装饰效果（可选，图片中不明显但增强视觉效果） */
      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 8px;
        height: 8px;
        border: 1px dashed #ff976a;
      }

      &::before {
        top: -1px;
        left: -1px;
        border-right: none;
        border-bottom: none;
      }

      &::after {
        top: -1px;
        right: -1px;
        border-left: none;
        border-bottom: none;
      }

      .corner-bottom-left,
      .corner-bottom-right {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 1px dashed #ff976a;
      }

      .corner-bottom-left {
        bottom: -1px;
        left: -1px;
        border-right: none;
        border-top: none;
      }

      .corner-bottom-right {
        bottom: -1px;
        right: -1px;
        border-left: none;
        border-top: none;
      }
    }

    .title {
      font-size: 14px;
      font-weight: 400;
      color: #333;
      line-height: 20px;
      margin-bottom: 16px;
    }

    .red {
      color: #f10000;
    }

    .form-info {
      .second-box {
        .section-title {
          position: relative;
          font-size: 16px;
          color: #3b70ff;
          font-weight: 700;
          margin-top: 20px;
          padding-left: 10px;
        }
      }
    }
  }

  .fixed {
    position: fixed;
    margin: 0 auto;
    left: 0;
    right: 0;
  }

  .ueditor-wrapper {
    padding: 0;
    word-wrap: break-word;
    cursor: text;
    height: 90%;
    margin: 8px;
    font-family: sans-serif;
    font-size: 16px;
    max-width: 100%;
    margin: 5px 0;
  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    padding: 5px 6px;
    background: #fff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, .12);

    ::v-deep .van-button--block {
      display: block;
      width: 100%;
    }
  }
}
</style>